import { authenticated_api } from "./base";
import {postLegacyEmail} from "./legacyEmailReplayConfig";

export const findAndVerifySpreadsheetEmailApi = (payload) =>
  authenticated_api.post('/enrichment/spreadsheet/find-and-verify-email', payload);

/**
 * Find emails for selected companies.
 * payload example:
 * {
 * domain: ["stripe.com", "apple.com"]
 * }
 */
export const findEmailBulkApi = async (payload, config = {}) => {
  try {
    return await postLegacyEmail(authenticated_api.post, "/enrichment/find-email", payload, config);
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    throw error;
  }
};

export const findSpreadsheetEmailBulkApi = async (payload, config = {}) => {
  try {
    return await postLegacyEmail(authenticated_api.post, "/enrichment/spreadsheet/find-email", payload, config);
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    throw error;
  }
};

/**
 * Verify emails (bulk or single). 
 * payload example:
 * {
 * emails: ["a@x.com", "b@x.com"],
 * provider: "hunter" // optional
 * }
 */
export const verifyEmailBulkApi = async (payload, config = {}) => {
  try {
    return await postLegacyEmail(authenticated_api.post, "/enrichment/verify-email", payload, config);
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    throw error;
  }
};

export const verifySpreadsheetEmailBulkApi = async (payload, config = {}) => {
  try {
    return await postLegacyEmail(authenticated_api.post, "/enrichment/spreadsheet/verify-email", payload, config);
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    throw error;
  }
};

/**
 * Execute AI enrichment for a single company.
 */
export const executeAiEnrichmentApi = async (payload, config = {}) => {
  try {
    return await authenticated_api.post("/ai-enrichment/execute", payload, config);
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    throw error;
  }
};

/**
 * Submit a batch of companies for AI enrichment
 */
export const submitBatchApi = async (payload, config = {}) => {
  try {
    return await authenticated_api.post("/batch/submit", payload, config);
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    throw error;
  }
};

/**
 * Get the status of an active batch
 */
export const getBatchStatusApi = async (batchId, config = {}) => {
  try {
    return await authenticated_api.get(`/batch/${batchId}`, config);
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    throw error;
  }
};

/**
 * Get the results for a batch
 */
export const getBatchResultsApi = async (batchId, config = {}) => {
  try {
    return await authenticated_api.get(`/batch/${batchId}/results`, config);
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    throw error;
  }
};

/**
 * Get the newest bounded history page for one company.
 */
export const getCompanyEnrichmentHistoryApi = async (companyId, config = {}) => {
  try {
    return await authenticated_api.get(
      `/ai-enrichment/companies/${encodeURIComponent(companyId)}/history`,
      config
    );
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    throw error;
  }
};
